/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SurfacePollOption
 */
export interface SurfacePollOption {
    /**
     * 
     * @type {string}
     * @memberof SurfacePollOption
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfacePollOption
     */
    imageId?: string;
    /**
     * Resolved CDN URL for the option image (populated from imageId)
     * @type {string}
     * @memberof SurfacePollOption
     */
    imageUrl?: string;
}

/**
 * Check if a given object implements the SurfacePollOption interface.
 */
export function instanceOfSurfacePollOption(value: object): value is SurfacePollOption {
    return true;
}

export function SurfacePollOptionFromJSON(json: any): SurfacePollOption {
    return SurfacePollOptionFromJSONTyped(json, false);
}

export function SurfacePollOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfacePollOption {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'] == null ? undefined : json['label'],
        'imageId': json['imageId'] == null ? undefined : json['imageId'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
    };
}

export function SurfacePollOptionToJSON(json: any): SurfacePollOption {
    return SurfacePollOptionToJSONTyped(json, false);
}

export function SurfacePollOptionToJSONTyped(value?: SurfacePollOption | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
        'imageId': value['imageId'],
        'imageUrl': value['imageUrl'],
    };
}

